// import React from 'react';

// import PropTypes from 'prop-types';
// import { Field } from 'react-final-form';

// import {
//     Button,
//     FormCheckbox,
//     Spinner,
// } from 'components';

// import FormInputField from 'components/FormInputField/FormInputField';
// import styles from './EmailTemplateForm.module.scss';

// const EmailTemplateForm = ({
//     values,
//     onPreview,
//     isEdit,
//     isBaseTemplate,
//     submitLabel,
//     submitting,
// }) => (
//     <>
//         <FormInputField
//             name="name"
//             label="Template Name"
//             placeholder={
//                 isEdit ? undefined : 'e.g. COUPON_REDEEMED'
//             }
//             required
//         />

//         <FormInputField
//             name="subject"
//             label="Subject"
//             placeholder={
//                 isEdit ? undefined : 'Enter email subject'
//             }
//             required
//         />

//         <div className={styles.formGroup}>
//             <label htmlFor="email-template-body">
//                 Body
//             </label>

//             <Field name="body">
//                 {({ input }) => (
//                     <textarea
//                         {...input}
//                         id="email-template-body"
//                         rows={14}
//                         className="form-control"
//                         placeholder={
//                             isEdit
//                                 ? undefined
//                                 : 'Enter email HTML'
//                         }
//                     />
//                 )}
//             </Field>
//         </div>

//         <Field name="enabled" type="checkbox">
//             {({ input, meta }) => (
//                 <FormCheckbox
//                     label="Enabled"
//                     input={input}
//                     meta={meta}
//                 />
//             )}
//         </Field>

//         <Field name="transactional" type="checkbox">
//             {({ input, meta }) => (
//                 <FormCheckbox
//                     label="Transactional"
//                     input={input}
//                     meta={meta}
//                 />
//             )}
//         </Field>

//         <div className="mb-3">
//             <Field
//                 name="useBaseTemplate"
//                 type="checkbox"
//             >
//                 {({ input, meta }) => (
//                     <FormCheckbox
//                         label="Use Base Email Template"
//                         input={{
//                             ...input,
//                             disabled: isBaseTemplate,
//                         }}
//                         meta={meta}
//                     />
//                 )}
//             </Field>
//         </div>

//         <div className={styles.actions}>
//             <Button
//                 outline
//                 type="button"
//                 onClick={() => onPreview(values)}
//                 disabled={submitting}
//             >
//                 Preview
//             </Button>

//             <Button
//                 type="submit"
//                 disabled={submitting}
//             >
//                 {submitting ? (
//                     <Spinner show />
//                 ) : (
//                     submitLabel
//                 )}
//             </Button>
//         </div>
//     </>
// );

// EmailTemplateForm.propTypes = {
//     values: PropTypes.object.isRequired,
//     onPreview: PropTypes.func.isRequired,
//     isEdit: PropTypes.bool.isRequired,
//     isBaseTemplate: PropTypes.bool,
//     styles: PropTypes.object.isRequired,
//     submitLabel: PropTypes.string.isRequired,
//     submitting: PropTypes.bool.isRequired,
// };

// EmailTemplateForm.defaultProps = {
//     isBaseTemplate: false,
// };

// export default EmailTemplateForm;

import React from 'react';

import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

import {
    Button,
    FormCheckbox,
    Spinner,
} from 'components';

import FormInputField from 'components/FormInputField/FormInputField';

import styles from './EmailTemplateForm.module.scss';

const EmailTemplateForm = ({
    values,
    onPreview,
    onSendTestEmail,
    isEdit,
    isBaseTemplate,
    submitLabel,
    submitting,
}) => (
    <>
        <FormInputField
            name="name"
            label="Template Name"
            placeholder={
                isEdit
                    ? undefined
                    : 'e.g. COUPON_REDEEMED'
            }
            required
        />

        <FormInputField
            name="subject"
            label="Subject"
            placeholder={
                isEdit
                    ? undefined
                    : 'Enter email subject'
            }
            required
        />

        <div className={styles.formGroup}>
            <label htmlFor="email-template-body">
                Body
            </label>

            <Field name="body">
                {({ input }) => (
                    <textarea
                        {...input}
                        id="email-template-body"
                        rows={14}
                        className="form-control"
                        placeholder={
                            isEdit
                                ? undefined
                                : 'Enter email HTML'
                        }
                    />
                )}
            </Field>
        </div>

        <Field name="enabled" type="checkbox">
            {({ input, meta }) => (
                <FormCheckbox
                    label="Enabled"
                    input={input}
                    meta={meta}
                />
            )}
        </Field>

        <Field
            name="transactional"
            type="checkbox"
        >
            {({ input, meta }) => (
                <FormCheckbox
                    label="Transactional"
                    input={input}
                    meta={meta}
                />
            )}
        </Field>

        <div className="mb-3">
            <Field
                name="useBaseTemplate"
                type="checkbox"
            >
                {({ input, meta }) => (
                    <FormCheckbox
                        label="Use Base Email Template"
                        input={{
                            ...input,
                            disabled: isBaseTemplate,
                        }}
                        meta={meta}
                    />
                )}
            </Field>
        </div>

        <div className={styles.actions}>
            <Button
                outline
                type="button"
                onClick={() => onPreview(values)}
                disabled={submitting}
            >
                Preview
            </Button>

            <Button
                outline
                type="button"
                onClick={() =>
                    onSendTestEmail(values)
                }
                disabled={submitting}
            >
                Send Test Email
            </Button>

            <Button
                type="submit"
                disabled={submitting}
            >
                {submitting ? (
                    <Spinner show />
                ) : (
                    submitLabel
                )}
            </Button>
        </div>
    </>
);

EmailTemplateForm.propTypes = {
    values: PropTypes.object.isRequired,
    onPreview: PropTypes.func.isRequired,
    onSendTestEmail: PropTypes.func.isRequired,
    isEdit: PropTypes.bool.isRequired,
    isBaseTemplate: PropTypes.bool,
    submitLabel: PropTypes.string.isRequired,
    submitting: PropTypes.bool.isRequired,
};

EmailTemplateForm.defaultProps = {
    isBaseTemplate: false,
};

export default EmailTemplateForm;